import axios from "@/libs/api.request";
export const getClientContract = params => {
  return axios.request({
    url: "/user/client/contract",
    method: "GET",
    params
  });
};

export const getContract = params => {
  return axios.request({
    url: "/common/contract",
    method: "GET",
    params
  });
};
